export const AppointmentAnalyticsFeatureFlags = {
  demoData: 'appointment-analytics-demo-data',
} as const;
